import React from 'react';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Paper } from '@mui/material';

import WrappedSpinner from '../common/wrapped-spinner';
import taskActions from '../../actions/tasks';
import vehicleActions from '../../actions/vehicles';
import locationActions from '../../actions/locations';
import zoneActions from '../../actions/zones';
import wranglerActions from '../../actions/wranglers';
import * as snackbarActions from '../../actions/snackbar';
import { VehicleDataTable } from './vehicles-page/vehicle-table';
import {
  sortByIntegerString,
  shouldFetchList,
} from '../../lib/utils';

const styles = {
  root: {
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto',
    overflowX: 'auto',
  },
};

class BaseVehicleTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVehicleFormOpen: false,
      editVehicle: {},
    };
  }

  componentDidMount() {
    const {
      fetchWranglers, fetchLocations, fetchZones,
      fetchTasks, fetchVehicles, match,
      vehicles, tasks, zones, locations,
    } = this.props;

    const marketId = get(match, 'params.marketId');
    if (marketId) {
      fetchWranglers({ market_id: marketId });
      if (shouldFetchList(marketId, tasks)) fetchTasks({ market_id: marketId });
      if (shouldFetchList(marketId, zones)) fetchZones({ market_id: marketId });
      if (shouldFetchList(marketId, locations)) fetchLocations({ market_id: marketId });
      if (shouldFetchList(marketId, vehicles)) fetchVehicles({ market_id: marketId });
    }
  }

  render() {
    const {
      vehicles,
      vehiclesLoading,
      vehiclesLostLoading,
      market,
      markets,
      vehicleActivities,
      currentWrangler,
      showStatusFilter,
      fetchOneTask,
      wranglersById,
      selectedRows,
      handleRowsSelected,
      openVehicleForm,
    } = this.props;

    return (
      <Paper style={styles.root} sx={{ mt: 1 }}>
        <WrappedSpinner isLoading={vehiclesLoading || vehiclesLostLoading}>
          <VehicleDataTable
            market={market}
            markets={markets}
            vehicles={vehicles}
            vehicleActivities={vehicleActivities}
            currentWrangler={currentWrangler}
            showStatusFilter={showStatusFilter}
            handleViewVehicle={openVehicleForm}
            fetchOneTask={fetchOneTask}
            wranglersById={wranglersById}
            selectedRows={selectedRows}
            handleRowsSelected={handleRowsSelected}
          />
        </WrappedSpinner>
      </Paper>
    );
  }
}

const mapStateToProps = ({
  vehicles: reduxVehicles, wranglers, markets,
}, { vehicles }) => {
  const sortedVehicles = sortByIntegerString(vehicles);
  const wranglersById = keyBy(wranglers.marketWranglers, '_id');
  return {
    vehiclesLoading: reduxVehicles.isLoading,
    vehiclesLostLoading: reduxVehicles.isLostLoading,
    vehicles: sortedVehicles,
    currentWrangler: wranglers.currentWrangler,
    wranglersById,
    market: markets.selectedMarket,
    markets: markets.markets,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...vehicleActions,
  ...taskActions,
  ...locationActions,
  ...zoneActions,
  ...wranglerActions,
  ...snackbarActions,
}, dispatch);

const VehicleTable = connect(mapStateToProps, mapDispatchToProps)(withRouter(BaseVehicleTable));
export { VehicleTable, BaseVehicleTable };
export default VehicleTable;
